import { TriangleAlert } from 'lucide-react';
import { cn } from '@/lib/utils';
import { AvailabilityInfoDto } from '@/features/dashboard/availability/types/AvailabilityDto.ts';

interface SeatLimitNoticeProps extends React.HTMLAttributes<HTMLDivElement> {
  availability: AvailabilityInfoDto;
}

/**
 * Ostrzeżenie o pozycji bez wolnych miejsc.
 *
 * Mówi wprost, że zapis w szkicu przejdzie, a odmowa przyjdzie dopiero przy
 * wprowadzaniu paczki — bo tak to działa i operator ma prawo wiedzieć, że
 * zapisuje coś, co może się nie udać. Liczby są z chwili otwarcia okna: miejsca
 * zajmuje ktoś inny w tle, więc to wskazówka, nie gwarancja.
 */
const SeatLimitNotice = ({
  availability,
  className,
  ...props
}: SeatLimitNoticeProps) => (
  <div
    role="status"
    className={cn(
      'rounded-lg border border-warning-100 bg-warning-50 px-3.5 py-2.5 text-sm text-neutral-800',
      className,
    )}
    {...props}
  >
    <p className="flex items-center gap-2 font-semibold text-ink">
      <TriangleAlert aria-hidden className="size-4 shrink-0 text-warning-100" />
      {availability.name} nie ma wolnych miejsc
    </p>
    <p className="mt-1">
      Zajęte {availability.currentCount} z {availability.limit}. Zapisać w
      szkicu można, ale wprowadzenie paczki zostanie odrzucone.
    </p>
  </div>
);

export default SeatLimitNotice;
